import { Link } from "react-router";
import "./error404.css";
const Error404 = () => {
  return (
    <div className="error-404-container">
      <img src={require("../assets/images/logo.png")} alt="logo" />
      <h1>Content Not Found</h1>
      <p className="error-404-text">
        The page or content you're looking for doesn't exist or has been moved.
        Please check the URL or return to the homepage.
      </p>
      <Link className="error-404-link" to="/">
        Go home
      </Link>
    </div>
  );
};

export default Error404;
